export function paginate<T>(array: T[], perPage: number, page: number): T[] {
  return array.slice(page * perPage, (page + 1) * perPage);
}
